<template>
  <div>
    <h2>ADMINISTRATOR</h2>

    <v-divider class="mt-3 mb-7"></v-divider>

    <v-card class="pa-3" flat>
      <v-row>
        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-account-circle </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Tambah ASN</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-text-box-check </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Verifikasi</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-account-supervisor </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Non Aktif</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-help-circle </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Anomali Data</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-list-box </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>DMS</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-cake-variant </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Ulang Tahun</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-book-open </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Laporan</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-chart-box </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Statistik</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber">
                mdi-information-variant-circle
              </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Pengumuman</h3>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="2">
          <v-card outlined>
            <div class="text-center pa-3" style="background-color: #eeeeee">
              <v-icon size="150" color="amber"> mdi-cog </v-icon>
            </div>

            <div class="pa-3 text-center">
              <h3>Pengaturan</h3>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
export default {
  data: () => ({
    token: Cookie.get("token"),
    session: "",
    foto: "",
  }),

  mounted() {
    this.session = JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {
    tglFormat(tgl) {
      const date = new Date(tgl);
      const dateTimeFormat = new Intl.DateTimeFormat("id", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      });
      const formatted = dateTimeFormat.formatToParts(date);
      return (
        formatted[0].value + " " + formatted[2].value + " " + formatted[4].value
      );
    },
  },
};
</script>
